<template>
	<div class="container-fluid">
		<div class="row header-panel nav-alt">
			<div class="col-3 left_side">
				<div class="login_logo_wrapper">
					<span>v2.0</span>
				</div>
			</div>
			<div class="col-9 right_side">
				<NavItem/>
			</div>

		</div>

		<div class="row content-panel content default-margin-top-content">
			<div class="col-12">
				<div class="title-panel d-flex justify-content-between align-items-center  content-header ">
					<div class="col-md-7 col-sm-5">
						<div class="title-text">
							განგაშები


						</div>
					</div>
					<div class="col-md-5 col-sm-8 button-panel d-flex align-items-start justify-content-end">
						<div class="form-group " style="visibility: hidden">
							<DateRangePicker element-id="user-daterange" date-range-value="dateRangeValue"/>
						</div>
						<div class=" col-md-4 col-sm-12  form-group mb-3">
							<v-select v-model="selectedAlertType" label="name" id="room-name" :options="alertTypes"
										placeholder="აირჩიეთ სტატუსი"
										@option:selected="onChangeAlertType">
								<template v-slot:no-options>სია ცარიელია</template>
							</v-select>
						</div>

					</div>
				</div>

				<div class="row">
					<div class="content-body tab-content"
						v-if="getReceivedAlerts && this.getReceivedAlerts.data && this.getReceivedAlerts.data.alerts.data.length > 0">
						<table class="table table-fixed">
							<thead>
							<tr>
								<td>
									<div class="d-flex ">
										<div v-if="parseInt(this.selectedAlertType.value) === 0"
											class="red-circle alt-circle" @click.prevent="readAll"
											title="ყველას წაკითხულად მონიშვნა"></div>
										<div v-else class="gray-circle alt-circle"></div>
										სტატუსი
									</div>
								</td>

								<td @click.prevent="sortBy('type')">
									ტიპი
									<template v-if="isFilteredBy('type')">
										<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
									</template>
								</td>

								<td @click.prevent="sortBy('datestamp')">
									თარიღი
									<template v-if="isFilteredBy('datestamp')">
										<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
									</template>
								</td>

								<td>
									განმარტება
								</td>

								<td @click.prevent="sortBy('controller.warehouse.name','controller.warehouse')">
									საწყობი
									<template v-if="isFilteredBy('controller.warehouse.name')">
										<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
									</template>
								</td>

								<td @click.prevent="sortBy('sensor.room_to_sensor.room.name','sensor.room_to_sensor.room')">
									ოთახი
									<template v-if="isFilteredBy('sensor.room_to_sensor.room.name')">
										<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
									</template>
								</td>

								<td @click.prevent="sortBy('sensor.name','sensor')">
									სენსორი
									<template v-if="isFilteredBy('sensor.name')">
										<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
									</template>
								</td>

								<td @click.prevent="sortBy('readed')">
									სტატუსის არჩევა
									<template v-if="isFilteredBy('readed')">
										<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
									</template>
								</td>

								<td>გრაფიკი</td>
							</tr>
							</thead>
							<tbody>
							<tr v-for="recAlert in getReceivedAlerts.data.alerts.data" :key="recAlert.id"
								:class="isSelected(recAlert.id)">
								<!--სტატუსი-->
								<td @click.prevent="makeReadedAlert(recAlert)">
									<div :class="getAlertColorClass(recAlert)"></div>
								</td>
								<!--ტიპი-->
								<td @click.prevent="makeReadedAlert(recAlert)">
									{{ $t('alr_'+recAlert.alert.alert_type.name)}}
								</td>
								<!--თარიღი-->
								<td>{{ getDate(recAlert.datestamp) }}</td>
								<!--განმარტება-->
								<td> {{ getAlertDescription(recAlert) }}</td>
								<!--საწყობი-->
								<td>{{ recAlert.controller.warehouse.name }}</td>
								<!--ოთახი-->
								<td>{{ getAlertRoom(recAlert) }}</td>
								<!--სენსორი-->
								<td>

									<template v-if="recAlert.sensor">
										{{ recAlert.sensor.name }}
										{{ recAlert.sensor.description ? `- ${recAlert.sensor.description} ` : '' }}

									</template>
									<template v-else> ყველა</template>

								</td>
								<!--სტატუსის არჩევა-->
								<td>
									<template v-if="!recAlert.readed">
										წაუკითხავი
									</template>
									<template v-else>
										წაკითხული
									</template>
								</td>
								<!--გრაფიკი-->
								<td><img src="/svgs/chart.svg" data-bs-toggle="modal" data-bs-target="#chartPopup"
										@click.prevent="showChart(recAlert)"/></td>
							</tr>
							</tbody>
						</table>
					</div>
					<div v-else>მონაცემები არ არის</div>


					<template v-if="this.last_page > 1">
						<v-pagination
							v-model="this.page"
							:pages="this.last_page"
							:range-size="1"
							active-color="#DCEDFF"
							@update:modelValue="paginationHandler"
						/>
					</template>

				</div>
			</div>
		</div>

	</div>

	<ChartPopup/>
</template>

<script>
import NavItem from "@/components/partials/NavItem";
import DateRangePicker from "@/components/partials/reusable/DateRangePicker";
import {ref} from "vue";
import moment from "moment";
import ChartPopup from "@/components/alert/ChartPopup";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import {useRoute} from "vue-router";

export default {
	name: "ReceivedAlerts",
	components: {ChartPopup, NavItem, DateRangePicker, VPagination},
	computed: {
		currentListName() {
			return this.readedState ? 'წაკითხული' : 'წაუკითხავი'
		},
		getReceivedAlerts() {
			return this.$store.state.alert.receivedAlerts
		},
		changeReadedAlert() {
			return this.$store.state.alert.changeReadedAlert
		},
		temperatures() {
			return this.$store.state.warehouse.temperatureData.data
		},
	},
	methods: {
		getAlertRoom(alert) {
			// Helper function to get room from sensors array
			const getRoomFromSensors = () => {
				return alert.sensors && alert.sensors.length > 0 && alert.sensors[0].room_to_sensor && alert.sensors[0].room_to_sensor.room 
					? alert.sensors[0].room_to_sensor.room.name 
					: '-- --';
			};

			if ([11,28].includes(alert.alert.alertstypeid)) {
				if (alert.alert.value4 === "-1") {
					return getRoomFromSensors();
				} else {
					return alert.sensor === null || alert.sensor.room_to_sensor === null ? '-- --' : alert.sensor.room_to_sensor.room.name
				}
			}
			if (alert.alert.alertstypeid === 31) {
				if (alert.alert.value2 === "-1") {
					return getRoomFromSensors();
				} else {
					return alert.sensor === null || alert.sensor.room_to_sensor === null ? '-- --' : alert.sensor.room_to_sensor.room.name
				}
			}
			return getRoomFromSensors();
		},
		isSelected(alertId) {
			const route = useRoute()
			const id = route.query.alertId
			if (id && parseInt(id) === alertId) {
				return 'active'
			}
			return ''
		},
		getAlertDescription(alert) {
			if ([11,28].includes(alert.alert.alertstypeid)) {
				let tempType = alert.value1 === "1" ? "ასცდა " : "ჩამოსცდა "
				return `${tempType} ლიმიტს : ${alert.value2} დაფიქსირდა:  ${alert.value3}`
			}

			if (alert.alert.alertstypeid === 31) {
				return 'სენსორი ' + alert.sensor.name + ' დაიკარგა კავშირი ' + alert.value1 + ' წუთით'
			}

			if (alert.alert.alertstypeid === 15) {
				let str = 'მოწყობილობა ' + alert.device.name + ', დაიკარგა კავშირი ' + moment(alert.value1).format('HH:mm:ss')
				if (alert.value2){
					str += ', აღდგა კავშირი ' + moment(alert.value2).format('HH:mm:ss')
				}
				return  str
			}

		},
		paginationHandler(page) {
			this.currentPage = page
			this.fetchAlerts()
		},
		isFilteredBy(key) {
			if (this.filteringState.key === key) {
				return true
			}
			return false
		},
		sortBy(key, nested = false) {
			this.changeFilterState(key)
			let splitedKey = key.split('.')[key.split('.').length - 1]

			this.getReceivedAlerts.data.alerts.data.sort((a, b) => {
				let comparableA = a[splitedKey]
				let comparableB = b[splitedKey]

				if (nested) {
					let path = nested.split('.')
					let tmpObj = null
					let tmpObjB = null
					for (let i = 0; i < path.length; i++) {
						if (i === 0) {
							tmpObj = a[path[0]]
							tmpObjB = b[path[0]]
							continue
						}
						if (tmpObj && tmpObjB) {
							tmpObj = tmpObj[path[i]]
							tmpObjB = tmpObjB[path[i]]
						}

					}
					if (tmpObj && tmpObjB) {
						comparableA = tmpObj[splitedKey]
						comparableB = tmpObjB[splitedKey]
					}
				}


				if (this.filteringState.ordering === 'DESC') {
					return comparableA > comparableB ? 1 : -1
				} else {
					return comparableA < comparableB ? 1 : -1
				}
			})
		},
		changeFilterState(key) {
			if (this.filteringState.key === key) {
				this.filteringState.ordering = this.filteringState.ordering === 'ASC' ? 'DESC' : 'ASC'
				return
			}
			this.filteringState.key = key
			this.filteringState.ordering = 'DESC'
		},
		getIconByOrdering() {
			let icon = 'sort-down'
			if (this.filteringState.ordering === 'DESC') {
				icon = 'sort-up'
			}
			return icon
		},
		fetchTemperatureData() {
			this.series = [{
				name: 'ტემპერატურა',
				data: [],

			}]
			this.series.push({
				name: 'ტენიანობა',
				data: [],
			})

			let alertDate = moment(this.chartAlert.datestamp, 'YYYY/MM/DD HH:mm:ss')

			let reqData = {
				sensorId: this.chartSensor !== null ? this.chartSensor.id : 0,
				alertId: this.chartAlert.id,
				start: alertDate.subtract(1, 'hours').format('YY/MM/DD').toString(),
				end: alertDate.add(1, 'hours').format('YY/MM/DD').toString(),
				range: "1"
			}
			// this.$store.dispatch('warehouse/fetchSensorTemperatureData',this.chartSensor.id).then(
			this.$store.dispatch('warehouse/fetchSensorTemperatureData', reqData).then(
				() => {
					let chartTimes = []
					let chartTempos = []
					let chartHumidity = []
					this.chartSensor = this.temperatures.sensor

					this.temperatures.data.forEach(item => {
						chartTimes.push(moment(item.trunc_60_minute).format('YYYY/MM/DDTHH:mm:ss[Z]'));
						chartTempos.push({
							y: item.tempo_average === null ? '0' : parseFloat(item.tempo_average),
							x: moment(item.trunc_60_minute).format('YYYY/MM/DDTHH:mm:ss[Z]')
						})
						chartHumidity.push({
							y: item.humidity_average === null ? '0' : parseFloat(item.humidity_average),
							x: moment(item.trunc_60_minute).format('YYYY/MM/DDTHH:mm:ss[Z]')
						})
					})

					this.series = [{
						name: 'ტემპერატურა',
						data: chartTempos,

					}]
					this.series.push({
						name: 'ტენიანობა',
						data: chartHumidity,
					})

					let sensorAlerts = this.temperatures.sensorAlerts.map(item => {
						return {
							y: parseFloat(item.value2),
							borderColor: '#f47b7a',
							strokeDashArray: 0,
							label: {
								show: true,
								text: parseInt(item.value1) === 1 ? `ლიმიტი აწევისას ${item.value2} ℃` : `ლიმიტი დაწევისას ${item.value2} ℃`,
								style: {
									color: "#fff",
									background: '#f47b7a'
								}
							}
						}
					})

					this.chartOptions = {
						...this.chartOptions,
						...{
							annotations: {
								yaxis: sensorAlerts
							}
						}
					}
				}
			)
		},
		showChart(recAlert) {
			this.chartSensor = recAlert.sensor ? recAlert.sensor : null
			this.chartAlert = recAlert
			this.fetchTemperatureData()
		},
		getAlertColorClass(alert) {
			if (alert.readed) {
				return 'gray-circle alt-circle'
			} else {
				return 'red-circle alt-circle'
			}
		},
		onChangeAlertType() {
			this.readedState = this.selectedAlertType.value
			this.fetchAlerts()
		},
		getDate(date) {
			return moment(date).format('D/M/YY HH:mm:ss')
		},

		makeReadedAlert(alert) {
			this.$store.state.alert.showingLastAlertIcon = false
			this.$store.dispatch('alert/makeAlertReaded', alert.id).then(
				() => {
					this.$store.state.alert.showingLastAlertIcon = false
					this.$router.push('received-alerts')
				}
			)
		},
		readAll() {
			this.$store.dispatch('alert/makeReadedAllAlert').then(
				() => {
					//todo clear list

					this.$store.state.alert.showingLastAlertIcon = false
					this.$router.push('received-alerts')
				}
			)
		},
		fetchAlerts() {
			let reqData = {
				page: this.currentPage,
				perPage: this.perPage,
			}
			if (this.readedState !== -1) {
				reqData.state = this.readedState ? 1 : 0
			}
			this.$store.dispatch('alert/getReceivedAlerts', reqData).then(() => {
				this.last_page = this.getReceivedAlerts.data.alerts.last_page
				this.page = this.getReceivedAlerts.data.alerts.current_page
			})
		}
	},
	data() {
		const chartTimes = ref([])
		let chartOptions = {
			grid: {
				strokeDashArray: 12,
			},
			colors: ["#9D85FF", "#5AA8ED"],
			chart: {
				id: 'chart',
				type: 'line',
				events: {
					beforeZoom: (e, {xaxis}) => {
						let maindifference = (new Date(this.series[0].data[0].x)).valueOf() - new Date(this.series[0].data[this.series[0].data.length - 1].x).valueOf();
						let zoomdifference = xaxis.max - xaxis.min;
						if (zoomdifference > maindifference)
							return {
								// dont zoom out any further
								xaxis: {
									min: this.series[0].data[0].date,
									max: this.series[0].data[this.series[0].data.length - 1].date
								}
							};
						else {
							return {
								// keep on zooming
								xaxis: {
									min: xaxis.min,
									max: xaxis.max
								}
							}
						}
					}
				}

			},
			dataLabels: {
				enabled: false
			},
			stroke: {
				curve: 'smooth'
			},
			xaxis: {
				type: 'datetime',
				categories: chartTimes,
				tooltip: {
					enabled: false
				}
			},
			yaxis: [
				{
					title: {
						text: 'ტემპერატურა',
					},
				},
				{
					opposite: true,
					title: {
						text: 'ტენიანობა',
					},
				}],
		}

		return {
			readedState: -1,
			currentPage: ref(1),
			perPage: ref(20),
			last_page: ref(0),
			page: ref(1),
			chartSensor: ref(null),
			chartAlert: ref(null),
			chartOptions: chartOptions,
			series: ref([]),
			alertTypes: ref([
				{name: 'ყველა', value: -1},
				{name: 'წაკითხული', value: 1},
				{name: 'წაუკითხავი', value: 0}
			]),
			selectedAlertType: ref({name: 'ყველა', value: -1}),
			filteringState: ref({
				ordering: 'DESC',
				key: null
			})
		}
	},
	mounted() {
		this.fetchAlerts()
	}
}
</script>

<style scoped>

.content {
	padding-bottom: 20px;
}

.content-header {
	border-bottom: 0;
}

.form-switch .form-check-input {
	width: 4em;
	height: 2em;
}

.form-group label {
	font-family: "TBCDinNusxuri-Bold";
}

.form-check-input:checked {
	background-color: var(--second-titles);
	border-color: var(--second-titles);
}

.table thead tr, .table tbody tr {
	text-align: left;
}

.modal-header {
	padding-bottom: 10px;
}

.tab-content {
	height: 76vh !important;
}


.apexcharts-canvas.apexchartschart.apexcharts-theme-light {
	padding-top: 10px !important;
}

tr.active {
	background-color: var(--hover-item);
}


</style>